<script setup lang="ts">
import { useRouter } from 'vue-router'
import { useAppStore } from '@/stores/app.store'
import { computed } from 'vue'
import SkeletonBase from '@/components/skeleton/SkeletonBase.vue'

// router
const router = useRouter()

// stores
const appStore = useAppStore()

// computed
const isLogin = computed(() => appStore.isLogin)
const loaded = computed(() => appStore.loaded)

// methods
const goHome = () => {
  router.push({ name: 'home' })
}
</script>

<template>
  <div v-if="loaded" @click="goHome" class="flex items-center gap-2 cursor-pointer">
    <img src="/favicon.svg" alt="Panatech Logo" :class="isLogin ? 'w-10' : 'w-14'" />
    <div :class="isLogin ? 'text-2xl' : 'text-4xl'" class="flex font-display">
      <span class="block">PANA</span>
      <span class="block text-blue-500">TECH</span>
      <span class="block text-purple-500">.</span>
    </div>
  </div>
  <div v-else class="flex">
    <skeleton-base width="60" height="10" rounded="xl" color="stone"></skeleton-base>
  </div>
</template>

<style scoped></style>
